import React from 'react';
import SimpleOptionCard from '../../../common/options/SimpleOptionCard';

const OptionsByCard = ({ selectedOptions, onDetails, type, analyticsKey }) => {
  const cards = selectedOptions.map((option) => {
    return (
      <SimpleOptionCard
        key={option.code}
        option={option}
        disabled
        onDetails={() => onDetails(option)}
        type={type}
        optionMarker={
          type === 'option' ? option.dealerInstalledLabel : option.optionMarker
        }
        analyticsKey={analyticsKey}
        checked={option.selected}
      />
    );
  });

  return <div className="math-box__option-grid">{cards}</div>;
};

export default OptionsByCard;
